import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';

@Component({
  selector: 'app-SubjectLetterAdd',
  templateUrl: './SubjectLetterAdd.component.html',
  styleUrls: ['./SubjectLetterAdd.component.scss']
})
export class SubjectLetterAddComponent implements OnInit {

  Token:String=""

  constructor(
    private SubjectLetter_Service:SubjectLetterService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewSubjectLetter=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,41).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewSubjectLetter:FormGroup;

  get_Form_Title(){
    return this.AddNewSubjectLetter.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewSubjectLetter(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.SubjectLetter_Service.AddSubject_Letter(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else{
          this.AddNewSubjectLetter.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



}
